import { useEffect, useState } from 'react'
import type { UserResponseDto } from '../types/generated'

/**
 * Hook для управления реферальным ключом пользователя
 *
 * Автоматически синхронизирует referralKey из профиля пользователя
 * и предоставляет методы для его установки/очистки
 *
 * @param userProfile - данные профиля пользователя
 * @param isLoading - флаг загрузки профиля
 * @returns {Object} - referralKey, метод для его установки и флаг загрузки
 */
export const useReferralKey = (
  userProfile: UserResponseDto | undefined,
  isLoading: boolean,
) => {
  const [referralKey, setReferralKey] = useState<string | null>(null)

  // Auto-sync referralKey from user profile
  useEffect(() => {
    if (userProfile?.referralKey) {
      setReferralKey(prevKey => {
        // Only update if the actual value has changed
        if (prevKey !== userProfile.referralKey) {
          return userProfile.referralKey
        }
        return prevKey
      })
    } else if (userProfile === undefined && !isLoading) {
      // Clear referral key only when user is not authenticated and not loading
      setReferralKey(null)
    }
  }, [userProfile, isLoading])

  return {
    referralKey,
    setReferralKey,
    isLoading,
  }
}
